<template>
  <el-button
    link
    :size="size"
    :disabled="disabled"
    :class="buttonClass"
    v-bind="buttonAttrs"
  >
    <app-icon v-if="resolvedIcon" :icon="resolvedIcon" class="table-action-btn__icon" />
    <span v-if="displayLabel" class="table-action-btn__label">{{ displayLabel }}</span>
    <slot v-else />
  </el-button>
</template>

<script>
import { resolveTableActionIcon } from '@/utils/tableActionIcons'

export default {
  name: 'TableActionBtn',
  inheritAttrs: false,
  props: {
    label: { type: String, default: '' },
    icon: { type: String, default: '' },
    size: { type: String, default: 'small' },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    buttonAttrs() {
      const { label, icon, size, disabled, class: className, ...rest } = this.$attrs
      return rest
    },
    buttonClass() {
      const extra = this.$attrs.class
      return ['table-action-btn', extra].filter(Boolean)
    },
    displayLabel() {
      return this.label || ''
    },
    resolvedIcon() {
      if (this.icon) return this.icon
      const attrs = Object.entries(this.$attrs)
        .map(([k, v]) => `${k}="${v}"`)
        .join(' ')
      const classStr = [this.$attrs.class, this.buttonClass.join(' ')].filter(Boolean).join(' ')
      const source = this.label || this.extractSlotText()
      return resolveTableActionIcon(source, `${attrs} ${classStr}`)
    },
  },
  methods: {
    extractSlotText() {
      const nodes = this.$slots.default?.() || []
      return nodes
        .map(node => {
          if (typeof node.children === 'string') return node.children
          if (Array.isArray(node.children)) {
            return node.children.filter(c => typeof c === 'string').join('')
          }
          return ''
        })
        .join('')
        .trim()
    },
  },
}
</script>
